import styled from "@emotion/styled";

export const ReviewListContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;
export const ReviewListWrapper = styled.div`
    width: calc(100%);
    display: flex;
    flex-direction: row;
    gap: 2rem;
    padding: 1rem;
`;
